import { classNames } from 'libs/react';
import { React } from 'libs/react';
import { Icon } from './Icon';
import './Email.scss';
/**
 * @component Email
 * @since 1.0.0
 */
export function Email(props) {
    const { style, value, icon } = Object.assign({ style: 'normal' }, props);
    const className = classNames('email', 'email--' + style, props.className);
    return (React.createElement("a", { className: className, href: 'mailto:' + value },
        icon && React.createElement(Icon, { value: "envelope" }),
        value));
}
